import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import Layout from "@xtribe/shared/components/lib/Layout/Layout";
import Navbar from "@xtribe/shared/components/lib/Navbar/Navbar";

const AGB = () => {
  return (
    <div>
      <NextHead
        title={"Unsere AGB's — xTribe"}
        description={"Hier findest du unsere allgemeinen Vertragsbedingungen"}
      />
      <Navbar />
      <Layout>
        <main className="mt-12 text-gray-700 max-w-6xl mx-auto px-2 md:px-4">
          <article className="page">
            <div className="page_wrapper u-cw">
              <div className="text-center mb-16">
                <h1 className="h1">AGB</h1>
                <p>July 11, 2018</p>
              </div>
              <div>
                <h3 className="mb-2 h3">
                  <b>Allgemeine Vertragsbedingungen</b>
                </h3>
                <p className="mb-4">(AV Bitkom, Version 2.1)</p>
                <p className="font-medium text-lg mb-4">
                  <b>1. Vergütung, Zahlung, Leistungsschutz, Termine </b>
                </p>
                <p className="mb-3">
                  <b>1.1 &nbsp;</b>Soweit nichts anderes vereinbart ist, wird
                  die Vergütung nach Aufwand zu den bei Vertragsschluss
                  allgemein gültigen Preisen des Anbieters berechnet.
                  Vergütungen sind grundsätzlich Netto-Preise zuzüglich
                  gesetzlich anfallender Umsatzsteuer.
                  <br />
                  Der Anbieter kann monatlich abrechnen. Werden Leistungen nach
                  Aufwand vergütet, dokumentiert der Anbieter die Art und Dauer
                  der Tätigkeiten und übermittelt diese Dokumentation mit der
                  Rechnung.
                  <br />
                </p>
                <p className="mb-3">
                  <b>1.2 &nbsp;</b>Alle Rechnungen sind grundsätzlich spätestens
                  14 Kalendertage nach Zugang frei Zahlstelle ohne Abzug zu
                  zahlen.{" "}
                </p>
                <p className="mb-3">
                  <b>1.3 &nbsp;</b>Der Kunde kann wegen Mängeln nur aufrechnen
                  oder Zahlungen zurückbehalten, soweit ihm tatsächlich
                  Zahlungsansprüche wegen Sach- oder Rechtsmängeln der Leistung
                  zustehen. Wegen sonstiger Mängelansprüche kann der Kunde
                  Zahlungen nur zu einem unter Berücksichtigung des Mangels
                  verhältnismäßigen Teil zurückbehalten. Ziffer 4.1 gilt
                  entsprechend. Der Kunde hat kein Zurückbehaltungsrecht, wenn
                  sein Mangelanspruch verjährt ist. Im Übrigen kann der Kunde
                  nur mit unbestrittenen oder rechtskräftig festgestellten
                  Forderungen aufrechnen oder eine Zurückbehaltung ausüben.{" "}
                </p>
                <p className="mb-3">
                  <b>1.4 &nbsp;</b>Der Anbieter behält sich das Eigentum und
                  einzuräumende Rechte an den Leistungen bis zur vollständigen
                  Bezahlung der geschuldeten Vergütung vor, berechtigte
                  Mängel-Einbehalte gemäß Ziffer 1.3. Satz 2 werden
                  berücksichtigt. Weiterhin behält sich der Anbieter das
                  Eigentum vor bis zur Erfüllung aller seiner Ansprüche aus der
                  Geschäftsbeziehung mit dem Kunden.
                  <br />
                  Der Anbieter ist berechtigt, für die Dauer eines
                  Zahlungsverzugs des Kunden diesem die weitere Nutzung der
                  Leistungen zu untersagen. Dieses Recht kann der Anbieter nur
                  für einen angemessenen Zeitraum gel- tend machen, in der Regel
                  höchstens für 6 Monate. Darin liegt kein Rücktritt vom
                  Vertrag. § 449 Abs. 2 BGB bleibt unberührt.
                  <br />
                  Geben der Kunde oder dessen Abnehmer die Leistungen zurück,
                  liegt in der Entgegennahme der Leistungen kein Rücktritt des
                  Anbieters, außer er hat den Rücktritt ausdrücklich erklärt.
                  Gleiches gilt für die Pfändung der Vorbehaltsware oder von
                  Rechten an der Vorbehaltsware durch den Anbieter.
                  <br />
                  Gegenstände unter Eigentums- oder Rechtsvorbehalt darf der
                  Kunde weder verpfänden noch sicherungs- übereignen. Dem Kunden
                  ist nur als Wiederverkäufer eine Weiterveräußerung im
                  gewöhnlichen Geschäftsgang unter der Bedingung gestattet, dass
                  dem Anbieter vom Kunden dessen Ansprüche gegen seine Abnehmer
                  im Zusammenhang mit der Weiterveräußerung wirksam abgetreten
                  worden sind und der Kunde seinem Abnehmer das Eigentum unter
                  Vorbehalt der Zahlung überträgt. Der Kunde tritt durch den
                  vorliegenden Vertragsabschluss seine künftigen Ansprüche im
                  Zusammenhang mit solchen Veräußerungen gegen seine Abnehmer
                  sicherungshalber an den Anbieter ab, der diese Abtretung
                  hiermit annimmt.{" "}
                </p>
                <p className="mb-3">
                  Soweit der Wert der Sicherungsrechte des Anbieters die Höhe
                  der gesicherten Ansprüche um mehr als 20 % übersteigt, wird
                  der Anbieter auf Wunsch des Kunden einen entsprechenden Anteil
                  der Sicherungs- rechte freigeben.{" "}
                </p>
                <p className="mb-3">
                  <b>1.5 &nbsp;</b>Der Kunde ist verpflichtet, bei einer
                  zulässigen Übertragung von Nutzungsrechten an Lieferungen und
                  Leistungen dem Empfänger deren vertraglich vereinbarte
                  Beschränkungen aufzuerlegen.
                  <br />
                </p>
                <p className="mb-3">
                  <b>1.6 &nbsp;</b>Gleicht der Kunde eine fällige Forderung zum
                  vertragsgemäßen Zahlungstermin ganz oder teilweise nicht aus,
                  kann der Anbieter vereinbarte Zahlungsziele für alle
                  Forderungen widerrufen. Der Anbieter ist ferner berechtigt,
                  weitere Leistungen nur gegen Vorkasse oder gegen Sicherheit
                  durch Erfüllungsbürgschaft eines in der Europäischen Union
                  zugelassenen Kreditinstituts oder Kreditversicherers
                  vorzunehmen. Die Vorkasse hat den jeweiligen
                  Abrechnungszeitraum oder – bei Einmalleistungen – deren
                  Vergütung zu umfassen.
                  <br />
                </p>
                <p className="mb-3">
                  <b>1.7 &nbsp;</b>Bei wirtschaftlichem Unvermögen des Kunden,
                  seine Pflichten gegenüber dem Anbieter zu erfüllen, kann der
                  Anbieter bestehende Austauschverträge mit dem Kunden durch
                  Rücktritt, Dauerschuldverhältnisse durch Kündigung fristlos
                  beenden, auch bei einem Insolvenzantrag des Kunden. § 321 BGB
                  und § 112 InsO bleiben unberührt. Der Kunde wird den Anbieter
                  frühzeitig schriftlich über eine drohende Zahlungsunfähigkeit
                  informieren.
                  <br />
                </p>
                <p className="mb-3">
                  <b>1.8 &nbsp;</b>Feste Leistungstermine sollen ausschließlich
                  ausdrücklich in dokumentierter Form vereinbart werden. Die
                  Vereinbarung eines festen Leistungstermins steht unter dem
                  Vorbehalt, dass der Anbieter die Leistungen seiner jeweiligen
                  Vorlieferanten rechtzeitig und vertragsgemäß erhält.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>
                    2. Zusammenarbeit, Mitwirkungspflichten, Vertraulichkeit{" "}
                  </b>
                </p>
                <p className="mb-3">
                  <b>2.1 &nbsp;</b>Kunde und Anbieter benennen jeweils einen
                  verantwortlichen Ansprechpartner. Die Kommunikation zwischen
                  dem Kunden und dem Anbieter erfolgt, soweit nichts anderes
                  vereinbart ist, über diese Ansprechpartner. Die
                  Ansprechpartner haben alle mit der Vertragsdurchführung
                  zusammenhängenden Entscheidungen unverzüglich herbeizuführen.
                  Die Entscheidungen sind verbindlich zu dokumentieren.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.2 &nbsp;</b>Der Kunde ist verpflichtet, den Anbieter
                  soweit erforderlich zu unterstützen und in seiner
                  Betriebssphäre alle zur ordnungsgemäßen Auftragsausführung
                  erforderlichen Voraussetzungen zu schaffen. Dazu wird er
                  insbesondere notwendige Informationen zur Verfügung stellen
                  und nach Möglichkeit einen Remotezugang auf das Kundensystem
                  ermöglichen. Soweit aus Sicherheitsgründen oder sonstigen
                  Gründen ein Remotezugang nicht möglich ist, verlängern sich
                  davon betroffene Fristen angemessen; für weitere Auswirkungen
                  werden die Vertragspartner eine angemessene Regelung
                  vereinbaren. Der Kunde sorgt ferner dafür, dass fachkundiges
                  Personal für die Unterstützung des Anbieters zur Verfügung
                  steht.
                  <br />
                  Soweit im Vertrag vereinbart ist, dass Leistungen vor Ort beim
                  Kunden erbracht werden können, stellt der Kunde auf Wunsch des
                  Anbieters unentgeltlich ausreichende Arbeitsplätze und
                  Arbeitsmittel zur Verfügung.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.3 &nbsp;</b>Soweit nichts anderes vereinbart ist, wird
                  der Kunde für eine ordnungsgemäße Datensicherung und
                  Ausfallvorsorge für Daten und Komponenten (etwa Hardware,
                  Software) sorgen, die deren Art und Bedeutung angemessen ist.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.4 &nbsp;</b>Der Kunde hat Mängel unverzüglich in
                  nachvollziehbarer und detaillierter Form unter Angabe aller
                  für die Mängelerkennung und -analyse zweckdienlichen
                  Informationen schriftlich zu melden. Anzugeben sind dabei
                  insbesondere die Arbeitsschritte, die zum Auftreten des
                  Mangels geführt haben, die Erscheinungs- form sowie die
                  Auswirkungen des Mangels. Soweit nichts anderes vereinbart
                  ist, werden dafür die ent- sprechenden Formulare und Verfahren
                  des Anbieters verwendet.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.5 &nbsp;</b>Der Kunde wird den Anbieter bei Prüfung und
                  Geltendmachung von Ansprüchen gegenüber anderen Beteiligten im
                  Zusammenhang mit der Leistungserbringung angemessen auf
                  Anforderung unterstützen. Dies gilt insbesondere für
                  Rückgriffsansprüche des Anbieters gegen Vorlieferanten.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.6 &nbsp;</b>Die Vertragspartner sind verpflichtet, über
                  Geschäfts- und Betriebsgeheimnisse sowie über sonstige als
                  vertraulich bezeichnete Informationen, die im Zusammenhang mit
                  der Vertragsdurchführung bekannt werden, Stillschweigen zu
                  wahren. Die Weitergabe solcher Informationen an Personen, die
                  nicht an dem Abschluss, der Durchführung oder Abwicklung des
                  Vertrags beteiligt sind, darf nur mit schriftlicher
                  Einwilligung des jeweils anderen Vertragspartners erfolgen.
                  Soweit nichts anderes vereinbart ist, endet diese
                  Verpflichtung nach Ablauf von fünf Jahren nach Bekanntwerden
                  der jeweiligen Information, bei Dauerschuldverhältnissen
                  jedoch nicht vor deren Beendigung.
                  <br />
                  Die Vertragspartner werden diese Verpflichtungen auch ihren
                  Mitarbeitern und eventuell eingesetzten Dritten auferlegen.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.7 &nbsp;</b>Den Vertragspartnern ist bekannt, dass eine
                  elektronische und unverschlüsselte Kommunikation
                  <br />
                  (z.B. per E-Mail) mit Sicherheitsrisiken behaftet ist. Bei
                  dieser Art der Kommunikation werden sie daher keine Ansprüche
                  geltend machen, die durch das Fehlen einer Verschlüsselung
                  begründet sind, außer soweit zuvor eine Verschlüsselung
                  vereinbart worden ist.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>3. Störungen bei der Leistungserbringung </b>
                </p>
                <p className="mb-3">
                  <b>3.1 &nbsp;</b>Wenn eine Ursache, die der Anbieter nicht zu
                  vertreten hat, einschließlich Streik oder Aussperrung, die
                  Termineinhaltung beeinträchtigt („Störung“), verschieben sich
                  die Termine um die Dauer der Störung,
                  <br />
                  erforderlichenfalls einschließlich einer angemessenen
                  Wiederanlaufphase. Ein Vertragspartner hat den anderen
                  Vertragspartner über die Ursache einer in seinem Bereich
                  aufgetretenen Störung und die Dauer der Verschiebung
                  unverzüglich zu unterrichten.
                  <br />
                </p>
                <p className="mb-3">
                  <b>3.2 &nbsp;</b>Erhöht sich der Aufwand aufgrund einer
                  Störung, kann der Anbieter auch die Vergütung des Mehraufwands
                  verlangen, außer der Kunde hat die Störung nicht zu vertreten
                  und deren Ursache liegt außerhalb seines
                  Verantwortungsbereichs.{" "}
                </p>
                <p className="mb-3">
                  <b>3.3 &nbsp;</b>Wenn der Kunde wegen nicht ordnungsgemäßer
                  Leistung des Anbieters vom Vertrag zurücktreten und / oder
                  Schadensersatz statt der Leistung verlangen kann oder solches
                  behauptet, wird der Kunde auf Ver- langen des Anbieters
                  innerhalb angemessen gesetzter Frist schriftlich erklären, ob
                  er diese Rechte geltend macht oder weiterhin die
                  Leistungserbringung wünscht. Bei einem Rücktritt hat der Kunde
                  dem Anbieter den Wert zuvor bestehender Nutzungsmöglichkeiten
                  zu erstatten; gleiches gilt für Verschlechterungen durch
                  bestimmungsgemäßen Gebrauch.
                  <br />
                  Gerät der Anbieter mit der Leistungserbringung in Verzug, ist
                  der Schadens- und Aufwendungsersatz des Kunden wegen des
                  Verzugs für jede vollendete Woche des Verzugs beschränkt auf
                  0,5 % des Preises für den Teil der vertraglichen Leistung, der
                  auf Grund des Verzugs nicht genutzt werden kann. Die
                  Verzugshaftung ist begrenzt auf insgesamt höchstens 5 % der
                  Vergütung für sämtliche, vom Verzug betroffene vertragliche
                  Leistungen; bei Dauerschuldverhältnissen bezogen auf die
                  Vergütung für die jeweils betroffenen Leistungen für das volle
                  Kalenderjahr. Ergänzend und vorrangig gilt ein bei
                  Vertragsabschluss vereinbarter Prozentsatz der bei
                  Vertragsabschluss vereinbarten Vergütung. Dies gilt nicht,
                  soweit ein Verzug auf grober Fahrlässigkeit oder Vorsatz des
                  Anbieters beruht.
                  <br />
                </p>
                <p className="mb-3">
                  <b>3.4 &nbsp;</b>Bei einer Verzögerung der Leistung hat der
                  Kunde im Rahmen der gesetzlichen Bestimmungen ein
                  Rücktrittsrecht nur, wenn die Verzögerung vom Anbieter zu
                  vertreten ist. Macht der Kunde wegen der Verzögerung
                  berechtigt Schadens- oder Aufwendungsersatz statt der Leistung
                  geltend, so ist er berechtigt, für jede vollendete Woche der
                  Verzögerung 1 % des Preises für den Teil der vertraglichen
                  Leistung zu verlangen, der auf Grund der Verzögerung nicht
                  genutzt werden kann, jedoch insgesamt höchstens 10 % dieses
                  Preises; bei Dauerschuldverhältnissen bezogen auf die
                  Vergütung für die jeweils betroffenen Leistungen für das volle
                  Kalenderjahr. Ergänzend und vorrangig gilt ein bei
                  Vertragsabschluss vereinbarter Prozentsatz der bei
                  Vertragsabschluss vereinbarten Vergütung.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>4. Sachmängel und Aufwendungsersatz </b>
                </p>
                <p className="mb-3">
                  <b>4.1 </b>Der Anbieter leistet Gewähr für die vertraglich
                  geschuldete Beschaffenheit der Leistungen. Für eine nur
                  unerhebliche Abweichung der Leistungen des Anbieters von der
                  vertragsgemäßen Beschaffenheit bestehen keine Ansprüche wegen
                  Sachmängeln.{" "}
                </p>
                <p className="mb-3">
                  Ansprüche wegen Mängeln bestehen auch nicht bei übermäßiger
                  oder unsachgemäßer Nutzung, natürlichem Verschleiß, Versagen
                  von Komponenten der Systemumgebung, nicht reproduzierbaren
                  oder anderweitig durch den Kunden nachweisbaren
                  Softwarefehlern oder bei Schäden, die aufgrund besonderer
                  äußerer Einflüsse entstehen, die nach dem Vertrag nicht
                  vorausgesetzt sind. Dies gilt auch bei nachträglicher
                  Veränderung oder Instandsetzung durch den Kunden oder Dritte,
                  außer diese erschwert die Analyse und die Beseitigung eines
                  Sachmangels nicht.{" "}
                </p>
                <p className="mb-3">
                  Für Schadensersatz- und Aufwendungsersatzansprüche gilt Ziffer
                  6 ergänzend.{" "}
                </p>
                <p className="mb-3">
                  <b>4.2 &nbsp;</b>Die Verjährungsfrist für Sachmangelansprüche
                  beträgt ein Jahr ab dem gesetzlichen Verjährungsbeginn. Die
                  gesetzlichen Fristen für den Rückgriff nach § 478 BGB bleiben
                  unberührt. Gleiches gilt, soweit das Gesetz gemäß § 438 Abs. 1
                  Nr. 2 oder § 634a Abs. 1 Nr. 2 BGB längere Fristen
                  vorschreibt, bei einer vorsätzlichen oder grob fahrlässigen
                  Pflichtverletzung des Anbieters, bei arglistigem Verschweigen
                  eines Mangels sowie in den Fällen der Verletzung des Lebens,
                  des Körpers oder der Gesundheit sowie für Ansprüche aus dem
                  Produkthaftungsgesetz.
                  <br />
                  Die Bearbeitung einer Sachmangelanzeige des Kunden durch den
                  Anbieter führt nur zur Hemmung der Verjährung, soweit die
                  gesetzlichen Voraussetzungen dafür vorliegen. Ein Neubeginn
                  der Verjährung tritt dadurch nicht ein.
                  <br />
                  Eine Nacherfüllung (Neulieferung oder Nachbesserung) kann
                  ausschließlich auf die Verjährung des die Nacherfüllung
                  auslösenden Mangels Einfluss haben.
                  <br />
                </p>
                <p className="mb-3">
                  <b>4.3 &nbsp;</b>Der Anbieter kann Vergütung seines Aufwands
                  verlangen, soweit{" "}
                </p>
                <p className="mb-3">
                  a) &nbsp;er aufgrund einer Meldung tätig wird, ohne dass ein
                  Mangel vorliegt, außer der Kunde konnte mit zumutbarem Aufwand
                  nicht erkennen, dass kein Mangel vorlag, oder{" "}
                </p>
                <p className="mb-3">
                  b) &nbsp;eine gemeldete Störung nicht reproduzierbar oder
                  anderweitig durch den Kunden als Mangel nachweisbar ist, oder{" "}
                </p>
                <p className="mb-3">
                  c) &nbsp;zusätzlicher Aufwand wegen nicht ordnungsgemäßer
                  Erfüllung der Pflichten des Kunden (siehe auch Ziffern 2.2,
                  2.3, 2.4 und 5.2) anfällt.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>5. Rechtsmängel </b>
                </p>
                <p className="mb-3">
                  <b>5.1 &nbsp;</b>Für Verletzungen von Rechten Dritter durch
                  seine Leistung haftet der Anbieter nur, soweit die Leistung
                  vertragsgemäß und insbesondere in der vertraglich
                  vereinbarten, sonst in der vorgesehenen Einsatzumgebung
                  unverändert eingesetzt wird.
                  <br />
                  Der Anbieter haftet für Verletzungen von Rechten Dritter nur
                  innerhalb der Europäischen Union und des Europäischen
                  Wirtschaftsraumes sowie am Ort der vertragsgemäßen Nutzung der
                  Leistung. Ziffer 4.1 Satz 1 gilt entsprechend.
                  <br />
                </p>
                <p className="mb-3">
                  <b>5.2 &nbsp;</b>Macht ein Dritter gegenüber dem Kunden
                  geltend, dass eine Leistung des Anbieters seine Rechte
                  verletzt, benachrichtigt der Kunde unverzüglich den Anbieter.
                  Der Anbieter und ggf. dessen Vorlieferanten sind berechtigt,
                  aber nicht verpflichtet, soweit zulässig die geltend gemachten
                  Ansprüche auf eigene Kosten abzuwehren.
                  <br />
                  Der Kunde ist nicht berechtigt, Ansprüche Dritter
                  anzuerkennen, bevor er dem Anbieter angemessen Gelegenheit
                  gegeben hat, die Rechte Dritter auf andere Art und Weise
                  abzuwehren.
                  <br />
                </p>
                <p className="mb-3">
                  <b>5.3 &nbsp;</b>Werden durch eine Leistung des Anbieters
                  Rechte Dritter verletzt, wird der Anbieter nach eigener Wahl
                  und auf eigene Kosten{" "}
                </p>
                <p className="mb-3">
                  a) &nbsp;dem Kunden das Recht zur Nutzung der Leistung
                  verschaffen oder{" "}
                </p>
                <p className="mb-3">
                  b) &nbsp;die Leistung rechtsverletzungsfrei gestalten oder{" "}
                </p>
                <p className="mb-3">
                  c) &nbsp;die Leistung unter Erstattung der dafür vom Kunden
                  geleisteten Vergütung (abzüglich einer angemessenen
                  Nutzungsentschädigung) zurücknehmen, wenn der Anbieter keine
                  andere Abhilfe mit angemessenem Aufwand erzielen kann.{" "}
                </p>
                <p className="mb-3">
                  Die Interessen des Kunden werden dabei angemessen
                  berücksichtigt.
                  <br />
                </p>
                <p className="mb-3">
                  <b>5.4 &nbsp;</b>Ansprüche des Kunden wegen Rechtsmängeln
                  verjähren entsprechend Ziffer 4.2. Für Schadensersatz- und
                  Aufwendungsersatzansprüche des Kunden gilt Ziffer 6 ergänzend,
                  für zusätzlichen Aufwand des Anbieters gilt Ziffer 4.3
                  entsprechend.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>6. Allgemeine Haftung des Anbieters </b>
                </p>
                <p className="mb-3">
                  <b>6.1 &nbsp;</b>Der Anbieter haftet dem Kunden stets{" "}
                </p>
                <p className="mb-3">
                  a) &nbsp;für die von ihm sowie seinen gesetzlichen Vertretern
                  oder Erfüllungsgehilfen vorsätzlich oder grob fahrlässig
                  verursachten Schäden,{" "}
                </p>
                <p className="mb-3">
                  b) &nbsp;nach dem Produkthaftungsgesetz und{" "}
                </p>
                <p className="mb-3">
                  c) &nbsp;für Schäden aus der Verletzung des Lebens, des
                  Körpers oder der Gesundheit, die der Anbieter, seine
                  gesetzlichen Vertreter oder Erfüllungsgehilfen zu vertreten
                  haben.
                  <br />
                </p>
                <p className="mb-3">
                  <b>6.2 &nbsp;</b>Der Anbieter haftet bei leichter
                  Fahrlässigkeit nicht, außer soweit er eine wesentliche
                  Vertragspflicht verletzt hat, deren Erfüllung die
                  ordnungsgemäße Durchführung des Vertrages überhaupt erst
                  ermöglicht oder deren Verletzung die Erreichung des
                  Vertragszwecks gefährdet und auf deren Einhaltung der Kunde
                  regelmäßig vertrauen darf.
                  <br />
                  Diese Haftung ist bei Sach- und Vermögensschäden auf den
                  vertragstypischen und vorhersehbaren Schaden beschränkt. Dies
                  gilt auch für entgangenen Gewinn und ausgebliebene
                  Einsparungen. Die Haftung für sonstige entfernte Folgeschäden
                  ist ausgeschlossen.
                  <br />
                  Für einen einzelnen Schadensfall ist die Haftung auf den
                  Vertragswert begrenzt, bei laufender Vergütung auf die Höhe
                  der Vergütung pro Vertragsjahr, jedoch nicht auf weniger als €
                  50.000. Für die Verjährung gilt Ziffer 4.2 entsprechend. Die
                  Vertragspartner können bei Vertragsabschluss eine
                  weitergehende Haftung, üblicherweise gegen eine gesonderte
                  Vergütung, schriftlich vereinbaren. Vorrangig ist eine
                  individuell vereinbarte Haftungssumme. Die Haftung gemäß
                  Ziffer 6.1 bleibt von diesem Absatz unberührt.
                  <br />
                </p>
                <p className="mb-3">
                  Ergänzend und vorrangig ist die Haftung des Anbieters wegen
                  leichter Fahrlässigkeit aus dem jeweiligen Vertrag und seiner
                  Durchführung auf Schadens- und Aufwendungsersatz - unabhängig
                  vom Rechtsgrund - insgesamt begrenzt auf den in diesem Vertrag
                  vereinbarten Prozentsatz der bei Vertragsabschluss
                  vereinbarten Vergütung. Die Haftung gemäß Ziffer 6.1 b) bleibt
                  von diesem Absatz unberührt.{" "}
                </p>
                <p className="mb-3">
                  <b>6.3 &nbsp;</b>Aus einer Garantieerklärung haftet der
                  Anbieter nur auf Schadensersatz, wenn dies in der Garantie
                  ausdrücklich übernommen wurde. Diese Haftung unterliegt bei
                  leichter Fahrlässigkeit den Beschränkungen gemäß Ziffer 6.2.
                  <br />
                </p>
                <p className="mb-3">
                  <b>6.4 &nbsp;</b>Bei notwendiger Wiederherstellung von Daten
                  oder Komponenten (etwa Hardware, Software) haftet der Anbieter
                  nur für denjenigen Aufwand, der für die Wiederherstellung bei
                  ordnungsgemäßer Datensicherung und Ausfallvorsorge durch den
                  Kunden erforderlich ist. Bei leichter Fahrlässigkeit des
                  Anbieters tritt diese Haftung nur ein, wenn der Kunde vor dem
                  Störfall eine der Art der Daten und Komponenten angemessene
                  Datensicherung und Ausfallvorsorge durchgeführt hat. Dies gilt
                  nicht, soweit dies als Leistung des Anbieters vereinbart ist.
                  <br />
                </p>
                <p className="mb-3">
                  <b>6.5 &nbsp;</b>Für Aufwendungsersatzansprüche und sonstige
                  Haftungsansprüche des Kunden gegen den Anbieter gelten Ziffern
                  6.1 bis 6.4 entsprechend. Ziffern 3.3 und 3.4 bleiben
                  unberührt.
                  <br />
                </p>
                <p className="p7">
                  <b>Datenschutz</b>
                </p>
                <p className="p8">
                  <b>
                    Der Kunde wird mit dem Anbieter datenschutzrechtlich
                    notwendige Vereinbarungen für den Umgang mit
                    personenbezogenen Daten abschließen.{" "}
                  </b>
                </p>
                <p className="p7">
                  <b>Sonstiges </b>
                </p>
                <p className="mb-3">
                  <b>8.1 &nbsp;</b>Der Kunde wird für die Lieferungen oder
                  Leistungen anzuwendende Import-und Export-Vorschriften
                  eigenverantwortlich beachten, insbesondere solche der USA. Bei
                  grenzüberschreitender Lieferung oder Leistung trägt der Kunde
                  anfallende Zölle, Gebühren und sonstige Abgaben. Der Kunde
                  wird gesetzliche oder behördliche Verfahren im Zusammenhang
                  mit grenzüberschreitenden Lieferungen oder Leistungen
                  eigenverantwortlich abwickeln, außer soweit anderes
                  ausdrücklich vereinbart ist.
                  <br />
                </p>
                <p className="mb-3">
                  <b>8.2 &nbsp;</b>Es gilt deutsches Recht. Die Anwendung des
                  UN-Kaufrechts ist ausgeschlossen.
                  <br />
                </p>
                <p className="mb-3">
                  <b>8.3 &nbsp;</b>Der Anbieter erbringt seine Leistungen unter
                  Zugrundelegung seiner Allgemeinen Geschäftsbedingungen (AGB).
                  AGB des Kunden finden keine Anwendung, auch wenn der Anbieter
                  solchen nicht ausdrücklich widersprochen hat.
                  <br />
                  Die Annahme der Leistungen durch den Kunden gilt als
                  Anerkennung der AGB des Anbieters unter Verzicht auf AGB des
                  Kunden.
                  <br />
                  Andere Bedingungen sind nur verbindlich, wenn der Anbieter sie
                  schriftlich anerkannt hat; ergänzend gelten dann die AGB des
                  Anbieters.
                  <br />
                </p>
                <p className="mb-3">
                  <b>8.4 &nbsp;</b>Änderungen und Ergänzungen dieses Vertrages
                  sollen nur schriftlich vereinbart werden. Soweit Schrift- form
                  vereinbart ist (z.B. für Kündigungen, Rücktritt), genügt
                  Textform nicht.
                  <br />
                </p>
                <p className="mb-3">
                  <b>8.5 &nbsp;</b>Gerichtsstand gegenüber einem Kaufmann, einer
                  juristischen Person des öffentlichen Rechts oder einem
                  öffentlich-rechtlichen Sondervermögen ist der Sitz des
                  Anbieters. Der Anbieter kann den Kunden auch an dessen Sitz
                  verklagen.
                  <br />
                </p>
                <p>&nbsp;</p>
                <h2 className="p1">
                  <b>
                    Vertragsbedingungen des Bitkom für die Nutzung von Software
                    über das Internet (Software as a Service)
                    <br />
                    -SaaS Bitkom-
                  </b>
                </h2>
                <p className="mb-4">(SaaS Bitkom, Version 2.1)</p>
                <p className="font-medium text-lg mb-4">
                  <b>1. Leistungen </b>
                </p>
                <p className="mb-3">
                  <b>1.1 &nbsp;</b>Der Anbieter stellt die
                  vertragsgegenständlichen Leistungen, insbesondere den Zugang
                  zur Software, in seinem Verfügungsbereich (ab Schnittstelle
                  Rechenzentrum zum Internet) bereit. Der Leistungsumfang, die
                  Beschaffenheit, der Verwendungszweck und die
                  Einsatzbedingungen der vertragsgegenständlichen Leistungen
                  ergeben sich aus der jeweiligen Leistungsbeschreibung,
                  ergänzend aus der Bedienungsanleitung der Software.{" "}
                </p>
                <p className="mb-3">
                  <b>1.2 &nbsp;</b>Darüber hinausgehende Leistungen, etwa die
                  Entwicklung kundenindividueller Lösungen oder erforderliche
                  Anpassungen bedürfen eines gesonderten Vertrages.{" "}
                </p>
                <p className="mb-3">
                  <b>1.3 &nbsp;</b>Der Anbieter kann aktualisierte Versionen der
                  Software bereitstellen.
                  <br />
                  Der Anbieter wird den Kunden über aktualisierte Versionen und
                  entsprechende Nutzungshinweise auf
                  <br />
                  elektronischem Wege informieren und diese entsprechend
                  verfügbar machen.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>2. Nutzungsumfang </b>
                </p>
                <p className="mb-3">
                  <b>2.1 &nbsp;</b>Die vertragsgegenständlichen Leistungen
                  dürfen nur durch den Kunden und nur zu den im Vertrag
                  vereinbarten Zwecken verwendet werden. Der Kunde darf während
                  der Laufzeit des Vertrages auf die vertragsgegenständlichen
                  Leistungen mittels Telekommunikation (über das Internet)
                  zugreifen und mittels eines Browsers oder einer anderen
                  geeigneten Anwendung (z.B. „App“) die mit der Software
                  verbundenen Funktionalitäten vertragsgemäß nutzen. Darüber
                  hinausgehende Rechte, insbesondere an der Software oder den
                  ggf. bereitgestellten Infrastrukturleistungen im jeweiligen
                  Rechenzentrum erhält der Kunde nicht. Jede weitergehende
                  Nutzung bedarf der vorherigen schriftlichen Zustimmung des
                  Anbieters.{" "}
                </p>
                <p className="mb-3">
                  <b>2.2 &nbsp;</b>Der Kunde darf die Software insbesondere
                  nicht über den vereinbarten Nutzungsumfang hinaus in Anspruch
                  nehmen oder von Dritten nutzen lassen oder sie Dritten
                  zugänglich machen. Insbesondere ist es dem Kunden nicht
                  gestattet, Software oder Teile davon zu vervielfältigen, zu
                  veräußern oder zeitlich begrenzt zu überlassen, zu vermieten
                  oder zu verleihen.{" "}
                </p>
                <p className="mb-3">
                  <b>2.3 &nbsp;</b>Der Anbieter ist berechtigt, angemessene
                  technische Maßnahmen zum Schutz vor einer nicht
                  vertragsgemäßen Nutzung zu treffen. Der vertragsgemäße Einsatz
                  der Leistungen darf dadurch nicht mehr als nur unwesentlich
                  beeinträchtigt werden.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.4 &nbsp;</b>Im Falle eines vertragswidrigen
                  Überschreitens des Nutzungsumfangs durch einen Nutzer oder im
                  Falle einer unberechtigten Nutzungsüberlassung hat der Kunde
                  dem Anbieter auf Verlangen unverzüglich sämtliche ihm
                  verfügbaren Angaben zur Geltendmachung der Ansprüche wegen der
                  vertragswidrigen Nutzung zu machen, insbesondere Name und
                  Anschrift des Nutzers mitzuteilen.{" "}
                </p>
                <p className="mb-3">
                  <b>2.5 &nbsp;</b>Der Anbieter kann die Zugangsberechtigung des
                  Kunden widerrufen und / oder den Vertrag kündigen, wenn der
                  Kunde die ihm gestattete Nutzung erheblich überschreitet oder
                  gegen Regelungen zum Schutz vor unberechtigter Nutzung
                  verstößt. Damit verbunden kann der Anbieter den Zugriff auf
                  die vertraglichen Leistungen unterbrechen bzw. sperren. Der
                  Anbieter hat dem Kunden vorher grundsätzlich eine angemessene
                  Nachfrist zur Abhilfe zu setzen. Der alleinige Widerruf der
                  Zugangsberechtigung gilt nicht zugleich als Kündigung des
                  Vertrages. Den Widerruf der Zugangsberechtigung ohne Kündigung
                  kann der Anbieter nur für eine angemessene Frist, maximal 3
                  Monate, aufrechterhalten.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.6 &nbsp;</b>Der Anspruch des Anbieters auf eine Vergütung
                  für die über die vereinbarte Nutzung hinausgehende Nutzung
                  bleibt unberührt.
                  <br />
                </p>
                <p className="mb-3">
                  <b>2.7 &nbsp;</b>Der Kunde hat einen Anspruch auf
                  Wiedereinräumung der Zugangsberechtigung und der
                  Zugriffsmöglichkeit, nachdem er nachgewiesen hat, dass er die
                  vertragswidrige Nutzung eingestellt und eine zukünftige
                  vertragswidrige Nutzung unterbunden hat.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>3. Verfügbarkeit, Leistungsmängel </b>
                </p>
                <p className="mb-3">
                  <b>3.1 &nbsp;</b>Die Verfügbarkeit der bereitgestellten
                  Leistungen ergibt sich aus der Leistungsbeschreibung.
                  <br />
                </p>
                <p className="mb-3">
                  <b>3.2 &nbsp;</b>Bei einer nur unerheblichen Minderung der
                  Tauglichkeit der Leistungen zum vertragsgemäßen Gebrauch
                  bestehen keine Ansprüche des Kunden wegen Mängeln. Die
                  verschuldens-unabhängige Haftung des Anbieters wegen Mängeln,
                  die bereits zum Zeitpunkt des Vertragsschlusses vorhanden
                  waren, ist ausgeschlossen.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>4. Datenschutz </b>
                </p>
                <p className="mb-3">
                  <b>4.1 &nbsp;</b>Soweit der Anbieter auf personenbezogene
                  Daten des Kunden oder aus dessen Bereich zugreifen kann, wird
                  er ausschließlich als Auftragsverarbeiter tätig und diese
                  Daten nur zur Vertragsdurchführung verarbeiten und nutzen. Der
                  Anbieter wird Weisungen des Kunden für den Umgang mit diesen
                  Daten beachten. Der Kunde trägt etwaige nachteilige Folgen
                  solcher Weisungen für die Vertragsdurchführung. Der Kunde wird
                  mit dem Anbieter die Details für den Umgang des Anbieters mit
                  den Daten des Kunden nach den datenschutzrechtlichen
                  Anforderungen vereinbaren.
                  <br />
                </p>
                <p className="mb-3">
                  <b>4.2 &nbsp;</b>Der Kunde bleibt sowohl allgemein im
                  Auftragsverhältnis als auch im datenschutzrechtlichen Sinne
                  der Verantwortliche. Verarbeitet der Kunde im Zusammenhang mit
                  dem Vertrag personenbezogene Daten (einschließlich Erhebung
                  und Nutzung), so steht er dafür ein, dass er dazu nach den
                  anwendbaren, insbesondere datenschutzrechtlichen Bestimmungen
                  berechtigt ist und stellt im Falle eines Verstoßes den
                  Anbieter von Ansprüchen Dritter frei.
                  <br />
                </p>
                <p className="mb-3">
                  <b>4.3 &nbsp;</b>Für das Verhältnis zwischen Anbieter und
                  Kunde gilt: Gegenüber der betroffenen Person trägt die
                  Verantwortung für die Verarbeitung (einschließlich Erhebung
                  und Nutzung) personenbezogener Daten der Kunde, außer soweit
                  der Anbieter etwaige Ansprüche der betroffenen Person wegen
                  einer ihm zuzurechnenden Pflichtverletzung zu vertreten hat.
                  Der Kunde wird etwaige Anfragen, Anträge und Ansprüche der
                  betroffenen Person verantwortlich prüfen, bearbeiten und
                  beantworten. Das gilt auch bei einer Inanspruchnahme des
                  Anbieters durch die betroffene Person. Der Anbieter wird den
                  Kunden im Rahmen seiner Pflichten unterstützen.{" "}
                </p>
                <p className="mb-3">
                  <b>4.4</b> Bei Verwendung der Cookie-Notice
                  Pop-Up-Einstellungen für Länder außerhalb der EU haftet der
                  Kunde im Falle der Missachtung der EU-DSGVO durch Aktivierung
                  ebendieser Popup-Einstellung innerhalb der EU.
                </p>
                <p className="mb-3">
                  <b>4.5 &nbsp;</b>Der Anbieter gewährleistet, dass Daten des
                  Kunden ausschließlich im Gebiet der Bundesrepublik
                  Deutschland, in einem Mitgliedsstaat der Europäischen Union
                  oder in einem anderen Vertragsstaat des Abkommens über den
                  Europäischen Wirtschaftsraum gespeichert werden, soweit nichts
                  anderes vereinbart ist.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>5. Pflichten des Kunden </b>
                </p>
                <p className="mb-3">
                  <b>5.1 &nbsp;</b>Der Kunde hat die ihm bzw. den Nutzern
                  zugeordneten Zugangsberechtigungen sowie Identifikations- und
                  Authentifikationsinformationen vor dem Zugriff durch Dritte zu
                  schützen und nicht an Unberechtigte weiterzugeben.
                  <br />
                </p>
                <p className="mb-3">
                  <b>5.2 &nbsp;</b>Der Kunde ist verpflichtet, den Anbieter von
                  sämtlichen Ansprüchen Dritter aufgrund von Rechtsverletzungen
                  freizustellen, die auf einer rechtswidrigen Verwendung des
                  Leistungsgegenstands durch ihn beruhen oder mit seiner
                  Billigung erfolgen. Erkennt der Kunde oder muss er erkennen,
                  dass ein solcher Verstoß droht, besteht die Pflicht zur
                  unverzüglichen Unterrichtung des Anbieters.
                  <br />
                </p>
                <p className="mb-3">
                  <b>5.3 &nbsp;</b>Der Kunde hat vom Anbieter zur Verfügung
                  gestellte Möglichkeiten zu nutzen, seine Daten in seinem
                  originären Verantwortungsbereich zu sichern.{" "}
                </p>
                <p className="p7">
                  <b>6. Benutzerinhalte</b>
                </p>
                <p className="mb-3">
                  Der Anbieter unterstützt keine Waren, Dienstleistungen,
                  Produkte, Werbeaktionen oder Angebote ("Benutzerinhalte"), die
                  über die Software bereitgestellt, verteilt, eingereicht oder
                  beworben oder mit der Software verwendet werden.
                </p>
                <p className="p7">
                  <b>
                    7. Akzeptable Nutzung (Zulässige Nutzung und Einschränkung
                    der Nutzung der Software)
                  </b>
                </p>
                <p className="mb-3">
                  Der Anbieter pflegt ein hohes Maß an Professionalität und
                  entsprechend unterliegt Ihre Lizenz von dem Anbieter zur
                  Nutzung der Software folgenden Einschränkungen und
                  Einschränkungen:
                </p>
                <p className="mb-3">
                  <b>7.1</b> Die Software darf nicht in Verbindung mit
                  Benutzerinhalten verwendet werden, die in irgendeiner Weise
                  eine der folgenden Handlungen beinhalten: falsche oder
                  irreführende Geschäftschancen, Betrug oder Schneeballsysteme;
                  gesundheitsbezogene Angaben, die von einer Regulierungsbehörde
                  als falsch oder irreführend eingestuft wurden; illegale
                  Aktivitäten; Verkauf von Drogen oder Arzneimitteln; Verkauf
                  von illegalen Produkten oder Dienstleistungen; Pornographie
                  oder sexuell expliziter Inhalt; Inhalte, die Menschenhandel,
                  Kindesmissbrauch, Tiermissbrauch fördern oder abbilden oder
                  die den Missbrauch von Alkohol, Drogen oder anderen Substanzen
                  verharmlosen, graphisch grundlose Gewalt oder Verletzungen,
                  Schläge, Verletzungen, Angriffe oder Erniedrigungen fördern;
                  und / oder Inhalte, die unnötigerweise für die Sinne
                  schockierend sind, grob eklatant sind oder Unfälle, Tod,
                  Hassreden, die eine Gruppe aufgrund von Rasse, ethnischer
                  Herkunft, Religion, Behinderung, Geschlecht, Alter und
                  dergleichen angreifen oder erniedrigen, darstellen oder
                  fördern. Jegliche Nutzung der Software im Zusammenhang mit
                  räuberischem Verhalten, einschließlich der Verletzung der
                  Privatsphäre, die auf andere Personen, insbesondere Kinder,
                  gerichtet ist, ist nicht zulässig und wird nicht toleriert;
                </p>
                <p className="mb-3">
                  <b>7.2</b> Der Anbieter behält sich das Recht vor,
                  Benutzerinhalte ohne vorherige Ankündigung abzulehnen oder zu
                  entfernen, wenn sie nach Ermessen des Anbieters diesen
                  Abschnitt, die „Zulässige Nutzung und Einschränkung der
                  Nutzung der Software“ verletzt oder auf andere Weise gegen
                  diese Vereinbarung verstößt. Der Anbieter behält sich außerdem
                  das Recht vor, einzelne oder alle Ihre Daten (einschließlich
                  Ihres Benutzerinhalts) ohne vorherige Ankündigung zu löschen,
                  nach Ablauf, Verfall oder Kündigung Ihrer Lizenz;
                </p>
                <p className="mb-3">
                  <b>7.3 </b>Ihre Nutzung der Software muss allen anwendbaren
                  Gesetzen und Bestimmungen entsprechen, einschließlich, aber
                  nicht beschränkt auf lokale, nationale und internationale
                  Gesetze und Vorschriften in Bezug auf:{" "}
                </p>
                <p className="mb-3">
                  {" "}
                  a) das Senden oder Verbreiten von unerwünschten kommerziellen
                  E-Mails;{" "}
                </p>
                <p className="mb-3">
                  {" "}
                  b) Online-Transaktionen in Bezug auf Heimarbeit oder andere
                  "Geschäftsmöglichkeiten";{" "}
                </p>
                <p className="mb-3"> c) falsche oder irreführende Werbung; </p>
                <p className="mb-3">
                  {" "}
                  d) das geistige Eigentum und die Persönlichkeitsrechte
                  anderer; und{" "}
                </p>
                <p className="mb-3">
                  {" "}
                  e) die Verwendung von bösartigem Code, Spyware, Malware,
                  Trojanischen Pferden und&nbsp; dergleichen; und
                </p>
                <p className="mb-3">
                  <b>7.4</b> Sie verpflichten sich darüber hinaus, die
                  Sicherheitsverfahren des Anbieters einschließlich
                  Passwortrichtlinien einzuhalten, keine von dem Anbieter
                  eingerichteten Sicherheits- oder Zugangsbestimmungen oder
                  -verfahren zu umgehen oder alternative Zugriffe zu
                  implementieren oder Hintertüren zur Software zu nutzen und den
                  Anbieter unverzüglich von Sicherheitsproblemen, die Sie
                  entdecken oder von denen Sie Kenntnis erlangen, zu
                  unterrichten.
                </p>
                <p className="p7">
                  <b>8. Geistige Eigentumsrechte</b>
                </p>
                <p className="mb-3">
                  <b>8.1 </b>Sie allein sind verantwortlich für Ihre eigenen
                  Inhalte und die Folgen des Erstellens, Kopierens, Einreichens,
                  Speicherns, Vertreibens, Veröffentlichens, Verkaufs oder
                  Anbietens von Nutzerinhalten mit Hilfe der Software. Sie
                  stimmen zu, bestätigen, versichern und gewährleisten, dass Sie
                  über alle Lizenzen, Rechte, Einwilligungen oder Berechtigungen
                  verfügen, die für alle Benutzerinhalte erforderlich sind, die
                  ganz oder teilweise von Ihnen mithilfe der Software kopiert,
                  verwendet, verteilt oder übermittelt werden ;
                </p>
                <p className="mb-3">
                  Sie behalten alle Ihre Eigentumsrechte an Ihren
                  Benutzerinhalten.
                </p>
                <p className="mb-3">
                  <b>8.2</b> Sie stimmen zu, bestätigen, vertreten und
                  garantieren, dass Inhalte, die Sie kopiert, verwendet,
                  verbreitet oder die von Ihnen mithilfe der Software
                  übermittelt wurden, kein urheberrechtlich geschütztes Material
                  oder Materialien enthalten, das Eigentumsrechten eines Dritten
                  unterliegt, es sei denn, Sie haben die Genehmigung des
                  rechtmäßigen Eigentümers des Materials oder Sie sind
                  anderweitig rechtlich berechtigt, diese Inhalte mit der
                  Software zu kopieren, zu verwenden, zu verteilen oder zu
                  übermitteln und dem Anbieter alle hierin gewährten
                  Lizenzrechte zu gewähren.{" "}
                </p>
                <p className="mb-3">
                  <b>8.3 </b>Der Anbieter wird niemals die Lizenz für Ihre
                  Benutzerinhalte zu irgendeinem anderen Zweck verwenden, als um
                  die Funktionalität der Software zu ermöglichen. Der Anbieter
                  wird Ihre Erlaubnis immer dann einholen, wenn Ihre
                  Nutzerinhalte zu Werbezwecken über eine nominelle /
                  unbeabsichtigte Weise genutzt werden sollen.{" "}
                </p>
                <p className="p8">
                  <b>9. Vertragswidrige Nutzung, Schadensersatz </b>
                </p>
                <p className="p9">
                  <b>9.1</b>
                  <b> </b>Für jeden Fall, in dem im Verantwortungsbereich des
                  Kunden unberechtigt eine vertragsgegenständliche Leistung in
                  Anspruch genommen wird, hat der Kunde jeweils Schadensersatz
                  in Höhe derjenigen Vergütung zu leisten, die für die
                  vertragsgemäße Nutzung im Rahmen der für diese Leistung
                  geltenden Mindestvertragsdauer angefallen wäre. Der Nachweis,
                  dass der Kunde die unberechtigte Nutzung nicht zu vertreten
                  hat oder kein oder ein wesentlich geringerer Schaden vorliegt,
                  bleibt dem Kunden vorbehalten. Der Anbieter bleibt berechtigt,
                  einen weitergehenden Schaden geltend zu machen.
                  <br />
                </p>
                <p className="p10">
                  <b>9.2 </b>Sie erklären sich damit einverstanden, den
                  Anbieter, seine leitenden Angestellten, Mitarbeiter und
                  Vertreter vor allen Ansprüchen, Schäden, Verpflichtungen,
                  Verlusten, Verbindlichkeiten, Kosten oder Schulden zu
                  schützen, zu entschädigen und Aufwendungen (einschließlich,
                  aber nicht beschränkt auf Kosten und Anwaltskosten) zu
                  übernehmen, die sich ergeben aus:{" "}
                </p>
                <p className="mb-3">
                  {" "}
                  a) Ihrer Nutzung der Software des Anbieters;{" "}
                </p>
                <p className="mb-3">
                  {" "}
                  b) Ihrer Verletzung irgendeiner Bedingung dieser Vereinbarung;{" "}
                </p>
                <p className="mb-3">
                  {" "}
                  c) Ihrer Verletzung der Rechte Dritter, einschließlich, aber
                  nicht beschränkt auf Urheberrechte oder andere Eigentumsrechte
                  oder Datenschutzrechte; oder{" "}
                </p>
                <p className="mb-3">
                  {" "}
                  d) jeglicher Behauptung, dass ein Nutzerinhalt, den Sie direkt
                  oder indirekt mit der Software angeboten, erstellt, kopiert,
                  verteilt oder beworben haben, Schaden an einer dritten Partei
                  verursacht hat. Diese Verteidigungs- und
                  Freistellungsverpflichtung bleibt auch nach Beendigung dieser
                  Vereinbarung bestehen und gilt auch dann, wenn Sie die Nutzung
                  der Software einstellen.
                </p>
                <p className="p11">
                  <b>10. </b>
                  <b>Störungsmanagement </b>
                </p>
                <p className="mb-3">
                  <b>10.1 </b>Der Anbieter wird Störungsmeldungen des Kunden
                  entgegennehmen, den vereinbarten Störungskategorien (Ziffer
                  7.3) zuordnen und anhand dieser Zuordnung die vereinbarten
                  Maßnahmen zur Analyse und Bereinigung von Störungen
                  durchführen.{" "}
                </p>
                <p className="mb-3">
                  <b>10.2 &nbsp;</b>Der Anbieter wird während seiner üblichen
                  Geschäftszeiten ordnungsgemäße Störungsmeldungen des Kunden
                  entgegennehmen und jeweils mit einer Kennung versehen. Auf
                  Anforderung des Kunden bestätigt ihm der Anbieter den Eingang
                  einer Störungsmeldung unter Mitteilung der vergebenen Kennung.{" "}
                  <br />
                </p>
                <p className="mb-3">
                  <b>10.3 &nbsp;</b>Soweit nichts anderes vereinbart ist, wird
                  der Anbieter entgegengenommene Störungsmeldungen nach erster
                  Sichtung einer der folgenden Kategorien zuordnen:
                  <br />
                  a) Schwerwiegende Störung
                  <br />
                  Die Störung beruht auf einem Fehler der
                  vertragsgegenständlichen Leistungen, der die Nutzung der
                  vertragsgegenständlichen Leistungen, insbesondere der
                  Software, unmöglich macht oder nur mit schwerwiegenden
                  Einschränkungen erlaubt. Der Kunde kann dieses Problem nicht
                  in zumutbarer Weise umgehen und deswegen unaufschiebbare
                  Aufgaben nicht erledigen.
                  <br />
                  b) Sonstige Störung
                  <br />
                  Die Störung beruht auf einem Fehler der
                  vertragsgegenständlichen Leistungen, der die Nutzung der
                  vertragsgegenständlichen Leistungen, insbesondere der
                  Software, durch den Kunden mehr als nur unwesentlich
                  einschränkt, ohne dass eine schwerwiegende Störung vorliegt.
                  <br />
                  c) Sonstige Meldung
                  <br />
                  Störungsmeldungen, die nicht in die Kategorien a) und b)
                  fallen, werden den sonstigen Meldungen zugeordnet. Sonstige
                  Meldungen werden vom Anbieter nur nach den dafür getroffenen
                  Vereinbarungen behandelt.
                  <br />
                </p>
                <p className="mb-3">
                  <b>10.4 &nbsp;</b>Bei Meldungen über schwerwiegende Störungen
                  und sonstige Störungen wird der Anbieter unverzüglich anhand
                  der vom Kunden mitgeteilten Umstände entsprechende Maßnahmen
                  einleiten, um zunächst die Störungsursache zu lokalisieren.
                  <br />
                  Stellt sich die mitgeteilte Störung nach erster Analyse nicht
                  als Fehler der vertragsgegenständlichen Leistungen,
                  insbesondere der bereitgestellten Software, dar, teilt der
                  Anbieter dies dem Kunden unverzüglich mit.
                  <br />
                  Sonst wird der Anbieter entsprechende Maßnahmen zur
                  weitergehenden Analyse und zur Bereinigung der mitgeteilten
                  Störung veranlassen oder – bei Drittsoftware – die
                  Störungsmeldung zusammen mit seinen Analyseergebnissen dem
                  Vertreiber oder Hersteller der Drittsoftware mit der Bitte um
                  Abhilfe übermitteln.
                  <br />
                </p>
                <p className="mb-3">
                  Der Anbieter wird dem Kunden ihm vorliegende Maßnahmen zur
                  Umgehung oder Bereinigung eines Fehlers der
                  vertragsgegenständlichen Leistungen, insbesondere der
                  bereitgestellten Software, etwa Handlungsanweisungen oder
                  Korrekturen der bereitgestellten Software, unverzüglich zur
                  Verfügung stellen. Der Kunde wird solche Maßnahmen zur
                  Umgehung oder Bereinigung von Störungen unverzüglich über-
                  nehmen und dem Anbieter bei deren Einsatz etwa verbleibende
                  Störungen unverzüglich erneut melden.{" "}
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>11. Ansprechstelle | Hotline</b>
                </p>
                <p className="mb-3">
                  <b>11.1 &nbsp;</b>Vertragliche Leistungen
                  <br />
                  Der Anbieter richtet eine Ansprechstelle für den Kunden ein.
                  Diese Stelle bearbeitet die Anfragen des Kunden im
                  Zusammenhang mit den technischen Einsatzvoraussetzungen und
                  -bedingungen der bereitgestellten Software sowie zu einzelnen
                  funktionalen Aspekten.
                  <br />
                </p>
                <p className="mb-3">
                  <b>11.2 &nbsp;</b>Annahme und Bearbeitung von Anfragen
                  <br />
                  Voraussetzung für die Annahme und Bearbeitung von Anfragen
                  ist, dass der Kunde gegenüber dem Anbieter fachlich und
                  technisch entsprechend qualifiziertes Personal benennt, das
                  intern beim Kunden mit der Bearbeitung von Anfragen der
                  Anwender der bereitgestellten Software beauftragt ist. Der
                  Kunde ist verpflichtet, nur über dieses dem Anbieter benannte
                  Personal Anfragen an die Hotline zu richten und dabei vom
                  Anbieter gestellte Formulare zu verwenden. Die Hotline nimmt
                  solche Anfragen per E-Mail und Chat während der üblichen
                  Geschäftszeiten des Anbieters entgegen.
                  <br />
                  Die Hotline wird ordnungsgemäße Anfragen im üblichen
                  Geschäftsgang bearbeiten und soweit möglich beantworten. Die
                  Hotline kann zur Beantwortung auf dem Kunden zugängliche
                  Dokumentationen und sonstige Ausbildungsmittel für die
                  bereitgestellte Software verweisen. Soweit eine Beantwortung
                  durch die Hotline nicht oder nicht zeitnah möglich ist, wird
                  der Anbieter – soweit dies ausdrücklich vereinbart ist – die
                  Anfrage zur Bearbeitung weiterleiten, insbesondere Anfragen zu
                  nicht von ihm hergestellter Software.
                  <br />
                  Weitergehende Leistungen der Hotline, etwa andere
                  Ansprechzeiten und -fristen sowie Rufbereitschaften oder
                  Einsätze des Anbieters vor Ort beim Kunden sind vorab
                  ausdrücklich zu vereinbaren.
                  <br />
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>12. Vertragslaufzeit und Vertragsbeendigung </b>
                </p>
                <p className="mb-3">
                  <b>12.1 &nbsp;</b>Die Erbringung der vertraglich vereinbarten
                  Leistungen erfolgt ab dem im Vertrag bezeichneten Datum
                  zunächst für die Dauer der im Vertrag vereinbarten Laufzeit.
                  Während dieser Mindestlaufzeit ist eine vorzeitige ordentliche
                  Kündigung beidseitig ausgeschlossen.
                  <br />
                </p>
                <p className="mb-3">
                  <b>12.2 &nbsp;</b>Der Jahres-Vertrag kann mit einer Frist von
                  zwei Wochen gekündigt werden, frühestens zum Ablauf der
                  Mindestlaufzeit. Geschieht dies nicht, verlängert sich der
                  Vertrag jeweils um ein weiteres Jahr, sofern er nicht mit
                  einer Frist von 2 Wochen zum Ablauf des jeweiligen
                  Verlängerungszeitraums ordentlich gekündigt wurde.
                  <br />
                  Der Monats-Vertrag kann bis spätestens zum letzten Tag der
                  Laufzeit gekündigt werden. Geschieht dies nicht, verlängert
                  sich der Vertrag jeweils um einen weiteren Monat, sofern er
                  nicht zum Ablauf des jeweiligen Verlängerungszeitraums
                  ordentlich gekündigt wurde.
                </p>
                <p className="mb-3">
                  <b>12.3 &nbsp;</b>Das Recht jedes Vertragspartners zur
                  außerordentlichen Kündigung aus wichtigem Grund bleibt
                  unberührt.
                  <br />
                </p>
                <p className="mb-3">
                  <b>12.4 &nbsp;</b>Jede Kündigungserklärung bedarf zu ihrer
                  Wirksamkeit der Schriftform. Es gilt Ziffer 8.4 AV Bitkom.
                  <br />
                </p>
                <p className="mb-3">
                  <b>12.5 &nbsp;</b>Der Kunde wird rechtzeitig vor Beendigung
                  des Vertrages seine Datenbestände eigenverantwortlich sichern
                  (etwa durch Download). Auf Wunsch wird der Anbieter den Kunden
                  dabei unterstützen, es gilt Ziffer 4.3 AV Bitkom. Eine
                  Zugriffsmöglichkeit des Kunden auf diese Datenbestände wird
                  nach Beendigung des Vertrages schon aus datenschutzrechtlichen
                  Gründen regelmäßig nicht mehr gegeben sein.{" "}
                </p>
                <p className="p13">
                  <b>13. Vergütung</b>
                </p>
                <p className="mb-3">
                  Für die SaaS-Leistungen wird eine im Vertrag vereinbarte
                  monatliche Gebühr berechnet. Die anfallenden Gebühren werden
                  über einen Zeitraum im Voraus in Rechnung gestellt.
                </p>
                <p className="p13">
                  <b>14. Zahlungsbedingungen</b>
                </p>
                <p className="mb-3">
                  Zahlungen erfolgen per Kreditkartenclearing oder PayPal. Bei
                  Überschreiten der Zahlungsfrist können im Verzugsfalle
                  Leistungen eingeschränkt werden.
                </p>
                <p className="mb-3">
                  Der Kunde ist nicht berechtigt, gegenüber dem Anbieter mit
                  Forderungen aufzurechnen, es sei denn, dass es sich um
                  rechtskräftig festgestellte Ansprüche oder von dem Anbieter
                  schriftlich anerkannte Ansprüche handelt.
                </p>
                <p className="font-medium text-lg mb-4">
                  <b>15. Geltung der AV Bitkom </b>
                </p>
                <p className="p15">
                  Ergänzend gelten die Allgemeinen Vertragsbedingungen des
                  Bitkom (AV Bitkom).{" "}
                </p>
              </div>
            </div>
          </article>
        </main>
      </Layout>
    </div>
  );
};

export default AGB;
